import React from 'react';

const useStateRef = (initialState) => {
    const _a = React.useState(initialState),
        state = _a[0],
        setState = _a[1];
    const ref = React.useRef(state);

    const dispatch = React.useCallback(function (setStateAction) {
        if (typeof setStateAction === 'function') {
            ref.current = setStateAction(ref.current);
        } else {
            ref.current = setStateAction;
        }

        setState(ref.current);
    }, []);

    return [state, dispatch, ref];
};

export default useStateRef;
